import React from 'react'
import '../Component/css/Tree.css'
import { useNavigate } from 'react-router-dom'
import header from '../assets/product/panion/Home-1.webp'
import header2 from '../assets/product/panion/Home-2.webp'
import solution from '../assets/product/panion/solution.webp'

// design process
import designprocess1 from '../assets/product/panion/Design Process-a.webp'
import designprocess2 from '../assets/product/panion/Design Process-b.webp'
import home from '../assets/product/panion/Home.webp'

// gamification
import game1 from '../assets/product/panion/game1.webp'
import game2 from '../assets/product/panion/game2.webp'

// accessibilty
import access1 from '../assets/product/panion/access1.webp'
import access2 from '../assets/product/panion/access2.webp'

// emphatize
import emp1 from '../assets/product/panion/emp1.webp'
import emp2 from '../assets/product/panion/emp2.webp'
import emp3 from '../assets/product/panion/emp3.webp'
import emp4 from '../assets/product/panion/emp4.webp'
import emp5 from '../assets/product/panion/emp5.webp'
import emp6 from '../assets/product/panion/emp6.webp'
import emp7 from '../assets/product/panion/emp7.webp'

// define
import def1 from '../assets/product/panion/def1.webp'
import def2 from '../assets/product/panion/def2.webp'
import def3 from '../assets/product/panion/def3.webp'
import def4 from '../assets/product/panion/def4.webp'


// ideate
import ide1 from '../assets/product/panion/ide1.webp'
import ide2 from '../assets/product/panion/ide2.webp'
import ide3 from '../assets/product/panion/ide3.webp'
import ide4 from '../assets/product/panion/ide4.webp'
import ide5 from '../assets/product/panion/ide5.webp'
import ide6 from '../assets/product/panion/ide6.webp'

// prototype
import pro1 from '../assets/product/panion/Pro1.webp'
import pro2 from '../assets/product/panion/Pro2.webp'
import pro3 from '../assets/product/panion/Pro3.webp'
import pro4 from '../assets/product/panion/Pro4.webp'
import pro5 from '../assets/product/panion/Pro5.webp'
import pro6 from '../assets/product/panion/Pro6.webp'

// test
import tes from '../assets/product/panion/Test.webp'
import tes1 from '../assets/product/panion/Test1.webp'
import tes2 from '../assets/product/panion/Test2.webp'

// screen
import screen1 from '../assets/product/panion/screen1.webp'
import screen2 from '../assets/product/panion/screen2.webp'
import screen3 from '../assets/product/panion/screen3.webp'

// video
import panionVideo from '../assets/product/panion/Panion.mp4'





const Panion = () => {

  const navigate = useNavigate()

  return (
    <div className="about">
      <section className="about-section sec-padding">
        <div className="container">
          <h1 className='projecth1'>Product.</h1>
          <div className="project-row">
          <div className='tree-project'>
{/* IMAGE BACKGROUND */}
          <img src={home} alt="background" className='treebg' />

{/* TIMELINE */}
          <div className="tree-timeline">
            <ul className='tree-ul'>
                <li className='tree-li'><div className="li">Challenge</div><span>An application that encourages individuals to engage in social activities online and offline. In addition, the application should improve people's social lifestyle and limit the feeling of loneliness by connecting users with individuals and groups that share similar interest</span></li>
                {/* <li className='tree-li'><div className="li">Role</div><span>Product Design, UX Research, and UX Case study</span></li> */}
                <li className='tree-li'><div className="li">Sector</div><span>Entertainment | Social Networking | Lifestyle </span></li>
                <li className='tree-li'><div className="li">Timeline</div><span>5 Month</span></li>
            </ul>
          </div>

{/* HEADER 1 */}
            <div className="tree-header-body">
              <div className="tree-header-detail">
                <div className="tree-header-text-one">
                  <div className="tree-main-text-one">
                    <h3>About</h3>
                    <div className="tree-icon">
                    <i class="fas fa-laptop"></i>
                    <i class="fas fa-tablet"></i>
                    </div>
                  </div>  
                    <p>
                    Panion is a non-governmental organization that pairs people with similar interests physically and online. The Panion application supplements the organization's goal to reach individuals globally. It features a hybrid social gathering that uses a ranking system to classify and recommend social events and activities. The design prototype is on  <strong><a href="https://www.figma.com/proto/Emup7oJpQWmXhp0fmJG00M/Panion--mobile-applicaion?page-id=0%3A1&node-id=142%3A1011&viewport=241%2C48%2C0.02&scaling=scale-down&starting-point-node-id=233%3A3320&show-proto-sidebar=1" target="_blank" rel="noopener noreferrer">Figma</a></strong>          
                    </p>             
                </div>
              </div>

              <div className="tree-header-image-one">
                <img src={header} alt="Tree Header" />
              </div>
          </div>

{/* PROBLEM */}
            <div className="tree-goal"> 
              <div className="tree-goal-image">
                  <img src={header2} alt="Tree Goal" />
              </div>
              <div className="tree-goal-text">
                <h3>Problem</h3>
                <p>As adults grow older they tend to feel lonely eventually leading to social isolation which is due to factors such as living alone, the loss of a loved one or chronic illness. According to National Academies of Sciences, Engineering, and Medicine (NASEM) “more than a third of adults aged 45 and above are lonely, and over a quarter of adults aged 65 and above are socially isolated”</p>
              </div>
            </div>

{/* GOAL */}
            <div className="tree-goal">
            <div className="tree-goal-image">
                  <img src={solution} alt="Tree Goal" />
            </div>
              <div className="tree-goal-text">
                <h3>Solution</h3>
                <p>Panion has decided to provide a platform to encourage social interaction by connecting people with similar interests to form a community where they can bond and create long-lasting friendships. The goal of Panion is to offer lonely individuals a chance to relate with people based on shared interests such as sports, fashion, politics, games etc</p>
              </div>
            </div>

{/* DESIGN PROCESS */}
            <div className="tree-detail">
              <div className="tree-detail-text">
                <div className="tree-detail-text-one">
                <h3>Design Process</h3>
                <p>By following the industry's conventional design process, I was able to gain a better understanding of the project and come up with solutions. To start, I empathized with current users of similar products and potential users of the application. Next, I defined the problem and created potential solutions. Later, I brainstormed to get the most suitable solution and focused on implementing that solution in the most appropriate way for the users. Soon, I began wireframing and building prototypes. Lastly, I ran multiple tests and implemented feedback.</p>
                </div>
              </div>
            </div>  

            <div className="tree-goal-image">
                  <img src={designprocess1} alt="Tree Goal" />
            </div>

            <div className="tree-goal-image">
                  <img src={designprocess2} alt="Tree Goal" />
            </div>

{/* GAMIFICATION */}
            <div className="tree-goal">
              <div className="tree-goal-image">
                    <img src={game1} alt="Tree Goal" />
              </div>
              <div className="tree-goal-image">
                    <img src={game2} alt="Tree Goal" />
              </div>
              <div className="tree-goal-text">
                <h3>Gamification</h3>
                <p>To promote users to engage in social activities frequently a game like technique was implemented when users book tickets for events. <strong><a href="https://www.growthengineering.co.uk/definition-of-gamification/" target="_blank" rel="noopener noreferrer">Gamification</a></strong> is shown in levels, as an individual engages in social events and gathering the users level goes up and gets extra points and bonuses</p>
              </div>
            </div>

{/* ACCESSIBILITY */}
            <div className="tree-goal">
              <div className="tree-goal-image">
                    <img src={access1} alt="Tree Goal" />
              </div>
              <div className="tree-goal-image">
                    <img src={access2} alt="Tree Goal" />
              </div>
              <div className="tree-goal-text">
                <h3>Accessibility</h3>
                <p>Asides from taking careful measurements in the design system to cater for the elderly, I decided to add extra features in the setting section by providing the <strong><a href="https://www.microsoft.com/en-us/research/blog/peoplelens-using-ai-to-support-social-interaction-between-children-who-are-blind-and-their-peers/" target="_blank" rel="noopener noreferrer">people lens</a></strong> by Microsoft for individuals who are partially blind, with low vision impairment or low cognitive ability. In addition, I added an assistive listening device (ADL) feature for users who have hearing disabilities and a text to speech feature for individuals who have speaking disabilities.</p>
              </div>
            </div>

{/* EMPHATIZE */}
            <div className="tree-goal">
              <div className="tree-goal-image">
                    <img src={emp7} alt="Tree Goal" />
              </div>
              <div className="tree-goal-image">
                    <img src={emp6} alt="Tree Goal" />
              </div>
              <div className="tree-goal-image">
                    <img src={emp5} alt="Tree Goal" />
              </div>
              <div className="tree-goal-image">
                    <img src={emp4} alt="Tree Goal" />
              </div>
              <div className="tree-goal-image">
                    <img src={emp3} alt="Tree Goal" />
              </div>
              <div className="tree-goal-image">
                    <img src={emp2} alt="Tree Goal" />
              </div>
              <div className="tree-goal-image">
                    <img src={emp1} alt="Tree Goal" />
              </div>
              <div className="tree-goal-text">
                <h3>Emphatize</h3>
                <p>I researched who the prospective users are, what they want, why and how the app can help solve the problem. later I looked up competitions of people who are currently solving similar problems and challenges. After studying the business. I analysed the competition and created an analysis of how Panion can take advantage. In addition, I created interview questions and conducted a series of interviews. Finally, I reviewed the interview answers and recordings and created an interview insight.</p>
              </div>
            </div>

{/* DEFINE */}
            <div className="tree-goal">
              <div className="tree-goal-image">
                    <img src={def4} alt="Tree Goal" />
              </div>
              <div className="tree-goal-image">
                    <img src={def3} alt="Tree Goal" />
              </div>
              <div className="tree-goal-image">
                    <img src={def2} alt="Tree Goal" />
              </div>
              <div className="tree-goal-image">
                    <img src={def1} alt="Tree Goal" />
              </div>
              <div className="tree-goal-text">
                <h3>Define</h3>
                <p>I figured out the problem and solution as to why loneliness has increased among individuals issues as the fear of reconnecting and meeting new people, and individuals from different religious, cultural, and financial backgrounds are likely to have a conflict of interest. Furthermore, I created possible solutions by considering the design question. Design questions such as how the application be fun and engaging for users?, how we should peer users with the same interest?, should the application cater for older people alone or youths and older people?. Lastly, I reviewed the interview results and carried out more interviews to get more data. </p>
              </div>
            </div>

{/* IDEATE */}
            <div className="tree-goal">
              <div className="tree-goal-image">
                    <img src={ide6} alt="Tree Goal" />
              </div>
              <div className="tree-goal-image">
                    <img src={ide5} alt="Tree Goal" />
              </div>
              <div className="tree-goal-image">
                    <img src={ide4} alt="Tree Goal" />
              </div>
              <div className="tree-goal-image">
                    <img src={ide3} alt="Tree Goal" />
              </div>
              <div className="tree-goal-image">
                    <img src={ide2} alt="Tree Goal" />
              </div>
              <div className="tree-goal-image">
                    <img src={ide1} alt="Tree Goal" />
              </div>
              <div className="tree-goal-text">
                <h3>Ideate</h3>
                <p>First, I came up with a lot of possible solutions to implement and I decided to narrow my focus by concentrating on the most appropriate solution. Next, I created a user flow across all touchpoints of the solution to understand where the user experience can be improved. As well as highlight the potential delights and opportunities Panion has to offer. Furthermore, To categorize all the features under different sections that contributed to the information architecture I developed a card sorting model. Finally, I modified the card sorting model to fit the aim of the application. The features were organized to create a seamless user experience.</p>
              </div>
            </div>

{/* IDEATE */}
            <div className="tree-goal">
              <div className="tree-goal-image">
                    <img src={pro6} alt="Tree Goal" />
              </div>
              <div className="tree-goal-image">
                    <img src={pro5} alt="Tree Goal" />
              </div>
              <div className="tree-goal-image">
                    <img src={pro4} alt="Tree Goal" />
              </div>
              <div className="tree-goal-image">
                    <img src={pro3} alt="Tree Goal" />
              </div>
              <div className="tree-goal-image">
                    <img src={pro2} alt="Tree Goal" />
              </div>
              <div className="tree-goal-image">
                    <img src={pro1} alt="Tree Goal" />
              </div>
              <div className="tree-goal-text">
                <h3>Prototype</h3>
                <p>I created wireframes for the main pages of the application which are interests, groups, events and, spaces. Later wireframed the accessibility and the level section. Additionally, I developed user scenarios and created physical as well as virtual prototypes for individuals to test the product. Lastly, I moved to the final phase of the design.</p>
              </div>
            </div>

{/* IDEATE */}
            <div className="tree-goal">
              <div className="tree-goal-image">
                    <img src={tes2} alt="Tree Goal" />
              </div>
              <div className="tree-goal-image">
                    <img src={tes1} alt="Tree Goal" />
              </div>
              <div className="tree-goal-image">
                    <img src={tes} alt="Tree Goal" />
              </div>
              <div className="tree-goal-text">
                <h3>Test</h3>
                <p>I began a series of testing with potential users and people I interviewed. After testing, the users had a lot of feedback that was implemented in the application. Finally, This process was repeated several times for the product to deliver the best possible experience for its users.</p>
              </div>
            </div>

{/* SCREEN */}
            <div className="tree-goal">
              <div className="tree-goal-image">
                    <img src={screen3} alt="Tree Goal" />
              </div>
              <div className="tree-goal-image">
                    <img src={screen2} alt="Tree Goal" />
              </div>
              <div className="tree-goal-image">
                    <img src={screen1} alt="Tree Goal" />
              </div>
              <div className="tree-goal-text">
                <h3>Screens</h3>
              </div>
            </div>


{/* VIDEO */}
             <div className="tree-detail-image">
                <video src={panionVideo} controls></video>
            </div>

{/* ANIMATION */}
        <h2 className='tree-h2'><span>Thanks for scrolling</span></h2>

        <p className='tree-p'>Schedule a <a href="https://calendly.com/tunde_dev" target="_blank"  rel="noopener noreferrer">demo call</a> to learn more about this project.</p>
        </div>

{/* End work Detail */}
                    <div onClick={() => navigate('/Portfolio')} className="go_to1">
                        <p>Go back to Portfolio</p> 
                        <div className="icon">
                            <i class="fas fa-angle-right"></i>
                            <i class="fas fa-angle-right"></i>
                        </div>
                    </div>
      </div>
    </div>
  </section>
  </div>
  )
}

export default Panion